/**
 * @file     mapPinHref.ts
 * @purpose  Build the "View on map" deep-link for a chat listing card: the
 *           /properties map reads pin_* params into a highlighted listingPin
 *           that self-centers at zoom 17 (see views/properties/index.tsx). This
 *           replaced the fragile ?address= text search and bbox-only centering.
 */
import type { MlsListingCardData } from '@/types/listing';
import { propertiesHref } from '@/core/config/places';

interface PinDisplay {
  title: string;
  price?: number | null;
  beds?: number | null;
  baths?: number | null;
  sqft?: number | null;
  href: string;
}

export function buildMapPinHref(listing: MlsListingCardData, display: PinDisplay): string {
  if (listing.latitude == null || listing.longitude == null) return display.href;
  return propertiesHref({
    pin_lat: listing.latitude,
    pin_lng: listing.longitude,
    pin_title: display.title,
    pin_href: display.href,
    pin_price: display.price,
    pin_beds: display.beds,
    pin_baths: display.baths,
    pin_sqft: display.sqft == null ? null : Math.round(display.sqft),
  });
}
